var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.552c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10zm-4.987-3.744A7.966 7.966 0 0012 20.552a7.97 7.97 0 005.167-1.892 6.98 6.98 0 00-5.007-2.108 6.982 6.982 0 00-5.147 2.256zm-1.397-1.436a8.975 8.975 0 016.544-2.82 8.972 8.972 0 016.362 2.634 8 8 0 10-12.906.186zM12 13.552a4 4 0 110-8 4 4 0 010 8zm0-2a2 2 0 100-4 2 2 0 000 4z"
  })));
};
export default SvgProfile;